import type { ViewportType } from "~/lib/map/types";

import { getBoundsFromViewport } from "./getBoundsFromViewport";

type ViewportGeometry = GeoJSON.Polygon | GeoJSON.MultiPolygon;

const MIN_LONGITUDE = -180;
const MAX_LONGITUDE = 180;
const LONGITUDE_RANGE = MAX_LONGITUDE - MIN_LONGITUDE;

export const getGeometryFromViewport = (viewport: ViewportType): ViewportGeometry => {
  const { north, south, east, west } = getBoundsFromViewport(viewport);
  const longitudeSpan = east - west;
  if (longitudeSpan >= LONGITUDE_RANGE) {
    return polygon(MIN_LONGITUDE, MAX_LONGITUDE, north, south);
  }

  const normalizedWest = normalizeLongitude(west);
  const normalizedEast = normalizedWest + longitudeSpan;
  if (normalizedEast <= MAX_LONGITUDE) {
    return polygon(normalizedWest, normalizedEast, north, south);
  }

  return {
    type: "MultiPolygon",
    coordinates: [
      polygonCoordinates(normalizedWest, MAX_LONGITUDE, north, south),
      polygonCoordinates(MIN_LONGITUDE, normalizedEast - LONGITUDE_RANGE, north, south),
    ],
  };
};

const normalizeLongitude = (longitude: number): number =>
  ((((longitude - MIN_LONGITUDE) % LONGITUDE_RANGE) + LONGITUDE_RANGE) % LONGITUDE_RANGE) + MIN_LONGITUDE;

const polygon = (west: number, east: number, north: number, south: number): GeoJSON.Polygon => ({
  type: "Polygon",
  coordinates: polygonCoordinates(west, east, north, south),
});

const polygonCoordinates = (west: number, east: number, north: number, south: number): GeoJSON.Position[][] => [
  [
    [west, north],
    [east, north],
    [east, south],
    [west, south],
    [west, north],
  ],
];
